import type { FunctionComponent, ReactNode } from 'react';

import IconChevron from 'assets/images/icon-chevron-20px-b.svg';

import S from './style..scss';

type PropsT = {
  children: ReactNode;
  collapsed?: boolean;
  icon: ReactNode;
  onExpand: () => void;
  title: string;
};

const CollapsibleTab: FunctionComponent<PropsT> = ({
  children,
  collapsed,
  icon,
  onExpand,
  title,
}) => {
  let className = S.container;
  if (collapsed) className += ` ${S.collapsed}`;

  return (
    <div
      className={className}
      onClick={collapsed ? onExpand : undefined}
      role="presentation"
    >
      <div styleName="header">
        <div styleName="iconAndTitle">
          {icon}
          {title}
        </div>
        <IconChevron styleName="chevron" />
      </div>
      {collapsed ? null : <div styleName="content">{children}</div>}
    </div>
  );
};

export default CollapsibleTab;
